import Page from "webPage/Page";
import ScrollMagic from "scrollmagic";
import {TimelineMax, TweenMax} from "gsap";
import {createController, registerScene, sectionGetHeight} from "../util/parallax";

Page.register('page-template-about', () => {
    createController();

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.page',
        duration: sectionGetHeight('.page'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-blue-1', 1, {y: 200}, {y: -2500, ease: Power0.easeNone}),
        TweenMax.fromTo('.js-circle-yellow-1', 1, {y: -200}, {y: 2500, ease: Power0.easeNone}),
    ])));

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--offset-image',
        duration: sectionGetHeight('.section--offset-image'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-green-of', 1, {y: -150}, {y: 150, ease: Power0.easeNone}),
    ])));

    registerScene(new ScrollMagic.Scene({
        triggerElement: '.section--float-image',
        duration: sectionGetHeight('.section--float-image'),
        triggerHook: "onEnter",
    }).setTween(new TimelineMax().add([
        TweenMax.fromTo('.js-circle-orange-2', 1, {y: 400}, {y: -100, ease: Power0.easeNone}),
    ])));
});
